import React from 'react';
import { ShowButton, TextInput, Filter, DateField, TextField, Datagrid } from 'react-admin';
import TList from '../../components/wrapper/TList';
import AmountField from '../../components/fields/AmountField';

const AccountingAccountItemFilter = ({ hideAccountIdFilter, ...props }) => (
	<Filter {...props}>
		{!hideAccountIdFilter &&
			<TextInput
				alwaysOn="true"
				label="resources.accountingAccountItems.filter.accountingAccount"
				source="accountId"
				resettable
			/>
		}
	</Filter>
);

const AccountingAccountItemList = ({ hideAccountIdFilter, ...props }) => (
	<TList exporter={false} {...props} sort={{ field: 'id', order: 'DESC' }} filters={<AccountingAccountItemFilter hideAccountIdFilter={hideAccountIdFilter} />}>
		<Datagrid>
			<ShowButton />
			<TextField source="id" />
			<DateField source="creationDateTime" showTime={true} />
			<TextField source="accountItemType" />
			<TextField source="accountItemStatus" />
			<AmountField source="amount" sortable={false} />
			<AmountField source="balance" sortable={false} />
			<AmountField source="turnover" sortable={false} />
		</Datagrid>
	</TList>
);

export default AccountingAccountItemList;
